import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from "antd";
import UnitOfMeasureType from "../../enums/UnitOfMeasureType";
import { CurrencyFormat } from "../../components/FormattersTS";
const MarketplaceFeesList = ({ fees }) => {
    if (fees == null || fees.length <= 0) {
        return null;
    }
    if (fees.filter(fee => fee.chargeAmountExTax).length < 1) {
        return null;
    }
    return (_jsx("span", { children: fees.map(fee => {
            if (fee.type === "PER_UOM") {
                const unitOfMeasure = UnitOfMeasureType.valueOf(fee.unitOfMeasure);
                const uomDescription = unitOfMeasure ? unitOfMeasure.shortDescription : fee.unitOfMeasure;
                return (_jsxs(React.Fragment, { children: [_jsxs(Tooltip, { title: fee.description, children: [_jsx(CurrencyFormat, { value: fee.chargeAmountExTax }), " / ", uomDescription, " ", _jsx(QuestionCircleOutlined, {})] }), _jsx("br", {})] }, fee.id));
            }
            return (_jsxs(React.Fragment, { children: [_jsxs(Tooltip, { title: fee.description, children: [_jsx(CurrencyFormat, { value: fee.chargeAmountExTax }), " ", _jsx(QuestionCircleOutlined, {})] }), _jsx("br", {})] }, fee.id));
        }) }));
};
export default MarketplaceFeesList;
